import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useAnnotations } from "../../store/annotations/hooks";
import { useModals } from "../../store/dialogs/hooks";
import { Transition } from "../../pages/app/utils/animation";
import { useEditorSelection } from "../../store/editor/hooks";

export const ExtractDialog = ({ lastValue, onCreate }) => {
  const { closeExtractDialog, showExtractDialog } = useModals();
  const { tagList } = useAnnotations();
  const { selectTag } = useEditorSelection();
  const [comment, setComment] = useState("");
  const [annotation, setAnnotation] = useState("");
  const [filteredTagList, setFilteredTagList] = useState([]);

  const handleChange = ({ target: { value } }) => {
    setAnnotation(value);
    selectTag(value);
  };

  const handleClose = () => closeExtractDialog();

  const handleCreate = () => {
    onCreate(annotation, comment);
    closeExtractDialog();
  };

  useEffect(() => {
    lastValue && setAnnotation(lastValue);
    setFilteredTagList(tagList.filter(Boolean));
  }, [lastValue, showExtractDialog, tagList]);

  return (
    <Dialog
      aria-hidden={!showExtractDialog}
      closeAfterTransition={false}
      maxWidth="xs"
      fullWidth
      onClose={handleClose}
      open={showExtractDialog}
      slots={{
        transition: Transition,
      }}
    >
      <DialogTitle>Create Model from Annotation</DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ mb: 2 }}>
          A new file will be created as part of this action. Select which named
          annotations to pull the model from.
        </DialogContentText>
        <FormControl fullWidth margin="normal">
          <InputLabel id="annotation-id-label">Annotation Name</InputLabel>
          <Select
            labelId="annotation-id-label"
            label="Annotation Name"
            value={annotation}
            onChange={handleChange}
            id="annotation"
            defaultValue={lastValue}
          >
            {filteredTagList.map((tag) => (
              <MenuItem key={tag} value={tag}>
                {tag}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          margin="normal"
          id="comment"
          placeholder="Comment"
          label="Optional Commit Message"
          rows={4}
          fullWidth
          multiline
          value={comment}
          onChange={(event) => setComment(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleCreate}
          variant="contained"
          disabled={!annotation}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};
